import { observer } from 'mobx-react-lite'
import { ReactNode, useEffect } from 'react'
import { useRootStore } from 'stores/RootStore'
import HandbookItemProvider from './HandbookItemProvider'

interface Props {
  handbookKey?: string
  children: ReactNode
}

export const HandbookProvider = observer(({ handbookKey, children }: Props) => {
  const rootStore = useRootStore()
  const handbook = rootStore.handbooks.get(handbookKey)

  useEffect(() => {
    if (!handbookKey || handbook) return

    rootStore.handbooks.fetch(handbookKey)
  }, [handbookKey, handbook, rootStore])

  return <HandbookItemProvider handbookKey={handbookKey}>{children}</HandbookItemProvider>
})
